import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LOADING_SCREEN_IMAGE, LOADING_SCREEN_IMAGE_ALT } from "./setting-up-call-loading-screen-consts";
import { withGenericConfig } from "contexts/generic-config-context";
import { StyledSettingUpCallLoadingScreen } from "contexts/supporting-components/loading-overlay/loading-screen-types/setting-up-call-loading-screen/setting-up-call-loading-screen.scss";
const SettingUpCallLoadingScreen = (props)=>{
    const { translate } = props;
    return /*#__PURE__*/ _jsxs(StyledSettingUpCallLoadingScreen, {
        children: [
            /*#__PURE__*/ _jsx("img", {
                src: LOADING_SCREEN_IMAGE,
                alt: LOADING_SCREEN_IMAGE_ALT,
                className: "loading-screen-image"
            }),
            /*#__PURE__*/ _jsx("h2", {
                className: "loading-screen-text",
                children: translate("contactOptions.loadingPage.settingUpCall")
            })
        ]
    });
};
export default withGenericConfig(SettingUpCallLoadingScreen);
